import { useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Per-game in-memory cache so re-opening a fantasy card is instant.
const cache = new Map();

function keyFor(game) {
  return [
    (game.sport || "").toLowerCase(),
    (game.home_team || "").toLowerCase(),
    (game.away_team || "").toLowerCase(),
    (game.date || "tbd").toLowerCase().slice(0, 10),
  ].join("|");
}

export function useGameFantasy() {
  // gameKey -> { loading, text, props_count, error }
  const [state, setState] = useState({});

  async function load(game, { force = false } = {}) {
    const k = keyFor(game);
    if (!force && state[k]?.text) return state[k];
    if (!force && cache.has(k)) {
      const cached = cache.get(k);
      setState((s) => ({ ...s, [k]: { loading: false, ...cached } }));
      return cached;
    }
    setState((s) => ({ ...s, [k]: { loading: true, text: state[k]?.text } }));
    try {
      const r = await axios.post(`${API}/games/fantasy-insights`, {
        sport: game.sport,
        home_team: game.home_team,
        away_team: game.away_team,
        date: game.date || null,
        time: game.time || null,
        platforms: game.platforms || [],
        force_refresh: !!force,
      }, { timeout: 60000 });
      const payload = {
        text: r.data?.fantasy || "",
        props_count: r.data?.props_count || 0,
      };
      cache.set(k, payload);
      setState((s) => ({ ...s, [k]: { loading: false, ...payload } }));
      return payload;
    } catch (err) {
      const msg = err?.response?.data?.detail || err?.message || "Could not load fantasy insights.";
      setState((s) => ({ ...s, [k]: { loading: false, error: msg } }));
      return null;
    }
  }

  function getFor(game) {
    return state[keyFor(game)] || {};
  }

  return { load, getFor };
}

// Sports where fantasy insights are supported (keep in sync with backend FANTASY_SPORTS).
export const FANTASY_SUPPORTED_SPORTS = new Set(["NFL", "NBA", "MLB", "NHL"]);
